import { useFormikContext } from "formik";
import { ManageThreadsApi, ThreadsApi, useAPIAction } from "melco-shared-logic";
import { useState } from "react";

export const useRevertThreads = (id: string, refetch: any) => {
  let dateOfLastRevert = new Date().getTime();
  const [revertKey, setRevertKey] = useState(dateOfLastRevert);
  const { resetForm } = useFormikContext();
  return [
    ...useAPIAction(
      ManageThreadsApi,
      async (api) => {
        let res = await api.threadsRevert({
          id: id,
        });
        // return res;
        return {
          successMessages: [
            {
              message: "Thread successfully reverted",
            },
          ],
          data: res,
        };
      },
      {
        translationPrefix: "managethreads.actions.revert",
        onSuccess: async () => {
          const response = await refetch();

          resetForm({
            values: response?.data ?? {},
          });
        },
      }
    ),
    revertKey,
  ] as const;
};
